import { render, staticRenderFns } from "./AuthSet2faBackupCode.vue?vue&type=template&id=2abb08fd&scoped=true"
import script from "./AuthSet2faBackupCode.vue?vue&type=script&lang=js"
export * from "./AuthSet2faBackupCode.vue?vue&type=script&lang=js"
import style0 from "./AuthSet2faBackupCode.vue?vue&type=style&index=0&id=2abb08fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb08fd",
  null
  
)

export default component.exports